import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const carouselStyles = makeStyles((theme: Theme) =>
  createStyles({
    carouselButton: {
        backgroundColor:'#D32F2F',
        fontFamily:'Hind Siliguri',
        fontSize:'24px',
        [theme.breakpoints.down('xs')]:{
            fontSize:'18px',
        }
    },
    carouselText:{
        marginTop:theme.spacing(8),
        marginBottom:theme.spacing(7),
        [theme.breakpoints.down('xs')]:{
            fontSize:'30px'
        }
    },
    imgCarousel:{
        height:'800px',
        opacity:'0.60',
        [theme.breakpoints.down('xs')]:{
            height:'500px',
        }
    },
    infoCarousel:{
        position:'absolute',
        bottom:'45%',
        left:'50%',
        marginLeft:'-45%',
        width:'90%',
        borderRadius:'10px',
        color:'#fff',
        padding:'10px',
        textAlign:'center'
    },
    infoCarouselBottom:{
        position:'absolute',
        bottom:'5%',
        left:'50%',
        marginLeft:'-45%',
        width:'90%',
        borderRadius:'10px',
        color:'#fff',
        padding:'10px',
        textAlign:'center'
    }
  }),
);

export default carouselStyles;